module.exports = __webpack_public_path__ + "img/1762008486305-3NBE5FIQ.df29a1b4.png";